import { apiGet } from './index'

/** 任务状态：1-待评鉴 2-已保存 3-已提交 */
export const TASK_STATUS_MAP = {
  1: '待评鉴',
  2: '已保存',
  3: '已提交',
}

/** 查询当前医生的医鉴任务统计 */
export const getMyTaskStats = () => apiGet('/api/caseReview/my/tasks/stats')

/** 分页查询当前医生的医鉴任务 */
export const getMyTasks = (params) => apiGet('/api/caseReview/my/tasks', params)

/** 查询当前医生进行中的医鉴批次 */
export const getMyActiveBatches = () => apiGet('/api/caseReview/my/active-batches')



// WEBPACK FOOTER //
// ./src/api/caseReview.js